module.exports = __webpack_public_path__ + "74b430df8d6dece9332fcde0c7bf8853.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/3930B.jpg
// module id = 684
// module chunks = 0